import React from "react";
import { PageHeader } from "@velocity-ehs/component-library";
import VerticalTabs from "../../sharedComponents/VerticalTabs";
import SPMetadataForm, { Mode } from "./SPMetadataForm";
import { useTranslation } from "react-i18next";

const AddSPMetadata: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <PageHeader
        title={t("action_add_application_config")}
        navigationTree={[
          { text: `Accelerate ${t("universal_Home")}`, href: "/" },
          {
            text: t("universal_Application_Config"),
            href: "/applicationConfig",
          },
          { text: t("universal_Add"), href: "" },
        ]}
      />
      <VerticalTabs
        tabs={[
          {
            content: <SPMetadataForm mode={Mode.Add} />,
            title: t("action_add_application_config"),
          },
        ]}
      />
    </>
  );
};

export default AddSPMetadata;
